import DeviceS10SEThumbnail from 'assets/images/device-s10se-x2.png';
import DeviceS10EProThumbnail from 'assets/images/device_s10_e_pro_thumbnail.png';
import DeviceS10EProCompactThumbnail from 'assets/images/device-s10eprocompact-x2.png';
import DeviceS10XThumbnail from 'assets/images/device-s10x-x2.png';
import DeviceS10XCompactThumbnail from 'assets/images/device-s10xcompact-x2.png';
import DeviceS20XProThumbnail from 'assets/images/s20xpro-x2.png';
import DeviceOneThumbnail from 'assets/images/one-160.png';

import DeviceS10SE from 'assets/images/s10e-produkt.png';
import DeviceS10EPro from 'assets/images/device_s10_e_pro.png';
import DeviceS10EProCompact from 'assets/images/s10e-pro-compact-produkt-667x1024.png';
import DeviceS10X from 'assets/images/s10x-produkt.png';
import DeviceS10XCompact from 'assets/images/s10x-compact-produkt-682x1024.png';
import DeviceS20XPro from 'assets/images/s20x-pro-compact-produkt.png';
import DeviceOne from 'assets/images/one-800.png';

import DeviceS10XPlusThumbnail from 'assets/images/Xplus-Serie-thumbnail.png';
import DeviceS10XPlus from 'assets/images/Xplus-Serie.png';
import DeviceS10XPlusCompactThumbnail from 'assets/images/Xplus-COMPACT-Serie-thumbnail.png';
import DeviceS10XPlusCompact from 'assets/images/Xplus-COMPACT-Serie.png';
import DeviceS10XFlexThumbnail from 'assets/images/Xflex-Serie-thumbnail.png';
import DeviceS10XFlex from 'assets/images/Xflex-Serie.png';
import DeviceS10XFlexCompactThumbnail from 'assets/images/Xflex-COMPACT-Serie-thumbnail.png';
import DeviceS10XFlexCompact from 'assets/images/Xflex-COMPACT-Serie.png';

const staticDeviceList = {
    ONE: {
        model: "one",
        thumbnail: DeviceOneThumbnail,
        image: DeviceOne
    },
    SESERIE: {
        model: "S10 SE",
        thumbnail: DeviceS10SEThumbnail,
        image: DeviceS10SE
    },
    XSERIE: {
        model: "S10 X Hauskraftwerk",
        thumbnail: DeviceS10XThumbnail,
        image: DeviceS10X
    },
    XCOMPACT: {
        model: "S10 X COMPACT",
        thumbnail: DeviceS10XCompactThumbnail,
        image: DeviceS10XCompact
    },
    S20XPRO: {
        model: "S20 X PRO",
        thumbnail: DeviceS20XProThumbnail,
        image: DeviceS20XPro
    },
    PROSERIE: {
        model: "S10 E PRO Hauskraftwerk",
        thumbnail: DeviceS10EProThumbnail,
        image: DeviceS10EPro,
    },
    PROCOMPACT: {
        model: "S10 E PRO COMPACT",
        thumbnail: DeviceS10EProCompactThumbnail,
        image: DeviceS10EProCompact
    },
    XPLUS: {
        model: "S10 Xplus",
        thumbnail: DeviceS10XPlusThumbnail,
        image: DeviceS10XPlus
    },
    XPLUSCOMPACT: {
        model: "S10 Xplus COMPACT",
        thumbnail: DeviceS10XPlusCompactThumbnail,
        image: DeviceS10XPlusCompact
    },
    XFLEX: {
        model: "S10 Xflex",
        thumbnail: DeviceS10XFlexThumbnail,
        image: DeviceS10XFlex
    },
    XFLEXCOMPACT: {
        model: "S10 Xflex COMPACT",
        thumbnail: DeviceS10XFlexCompactThumbnail,
        image: DeviceS10XFlexCompact
    }
}

export default staticDeviceList;
